var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7502 14C6.62872 14 3.07737 11.4318 1.55636 7.7483C3.02561 4.15628 6.63252 1.5 10.7502 1.5C14.8679 1.5 18.4748 4.15623 19.9441 7.7482C18.4231 11.4318 14.8717 14 10.7502 14ZM21.4525 7.4867C21.5203 7.6676 21.5138 7.8582 21.4481 8.0249C19.7812 12.3905 15.6278 15.5 10.7502 15.5C5.86964 15.5 1.71423 12.3868 0.0493489 8.017C-0.0194611 7.8364 -0.0138812 7.6457 0.0509688 7.4787C1.6561 3.20832 5.87131 0 10.7502 0C15.6322 0 19.8496 3.21229 21.4525 7.4867ZM7.50024 7.75C7.50024 5.9551 8.9553 4.5 10.7502 4.5C12.5452 4.5 14.0002 5.9551 14.0002 7.75C14.0002 9.5449 12.5452 11 10.7502 11C8.9553 11 7.50024 9.5449 7.50024 7.75ZM10.7502 3C8.12689 3 6.00024 5.12665 6.00024 7.75C6.00024 10.3734 8.12689 12.5 10.7502 12.5C13.3736 12.5 15.5002 10.3734 15.5002 7.75C15.5002 5.12665 13.3736 3 10.7502 3Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesIcon);
export default __webpack_public_path__ + "static/media/eyes-icon.5fbd398e7fe7d7b5e46645eff26cf344.svg";
export { ForwardRef as ReactComponent };